<script setup lang="ts">
/**
 * Layout monitoring : pas d’AuthGate ni de NoticeGate - l’accès repose sur le secret
 * (variable serveur et/ou saisie sur la page) et les routes health sécurisées.
 */
import iconPicture from '~/assets/images/logo.png'
import SourceTag from '~/components/ui/SourceTag.vue'
</script>

<template>
  <div class="monitoring-layout">
    <header class="monitoring-layout__header">
      <NuxtLink class="monitoring-layout__brand" to="/">
        <img :src="iconPicture" alt="Mon Orga" width="40" height="40">
        <span class="monitoring-layout__brand-title">Mon Orga</span>
      </NuxtLink>
      <SourceTag text="Monitoring" type="primary" size="xsmall" flat />
    </header>
    <div class="monitoring-layout__subnav">
      <NuxtLink class="monitoring-layout__back-national" to="/">
        <span class="material-symbols-rounded monitoring-layout__back-icon" aria-hidden="true">arrow_back</span>
        Retour à la vue nationale
      </NuxtLink>
    </div>
    <main class="monitoring-layout__main">
      <slot />
    </main>
  </div>
</template>

<style scoped lang="scss">
@use '~/assets/scss/partials/elpdl/spacing' as *;
@use '~/assets/scss/partials/elpdl/colors' as *;

.monitoring-layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: var(--color-bg, #{$enedis-neutral-30});
}

.monitoring-layout__header {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: $spacing-m;
  padding: $spacing-m $spacing-xl;
  background: var(--color-bg-header);
  border-bottom: 1px solid var(--color-border);
}

.monitoring-layout__brand {
  display: flex;
  align-items: center;
  gap: $spacing-m;
  text-decoration: none;
  color: inherit;
}

.monitoring-layout__brand-title {
  font-size: 1.125rem;
  font-weight: 700;
  color: $enedis-neutral-900;
}

.monitoring-layout__subnav {
  flex-shrink: 0;
  padding: $spacing-s $spacing-xl;
  background: var(--color-bg-elevated, #{$enedis-neutral-10});
  border-bottom: 1px solid var(--color-border);
}

.monitoring-layout__back-national {
  display: inline-flex;
  align-items: center;
  gap: $spacing-3xs;
  font-size: 0.9375rem;
  font-weight: 600;
  color: $enedis-primary-500;
  text-decoration: none;
  padding: $spacing-3xs $spacing-2xs;
  margin: (-$spacing-3xs) (-$spacing-2xs);

  &:hover {
    color: $enedis-primary-600;
    text-decoration: underline;
  }

  &:focus-visible {
    outline: 2px solid $enedis-primary-500;
    outline-offset: 2px;
  }
}

.monitoring-layout__back-icon {
  font-size: 1.125rem;
}

.monitoring-layout__main {
  flex: 1;
  padding: $spacing-xl $spacing-l;
}

.monitoring-layout__main > :deep(*) {
  width: 100%;
  max-width: min(93.75rem, calc(100vw - 3rem));
  margin-inline: auto;
  min-width: 0;
  box-sizing: border-box;
}
</style>
